<template>
    <div class="map-page">
        <div class="content">
            <!-- Map -->
            <div class="map-container column-map left-pos-map">
                <div id="map-main"></div>
                <ul class="mapnavigation">
                    <li><a href="#" class="direciton-click prevmap-nav" @click="directionClick($event, 'prev')">Prev</a></li>
                    <li><a href="#" class="direciton-click nextmap-nav" @click="directionClick($event, 'next')">Next</a></li>
                </ul>
                <div class="scrollContorl mapnavbtn" title="Enable Scrolling"><span><i class="fa fa-lock"></i></span></div>
            </div>
            <!-- Map end -->
            <!--col-list-wrap -->
            <div class="col-list-wrap right-list">
                <div class="listsearch-options fl-wrap" id="lisfw" >
                    <div class="container">
                        <div class="listsearch-header fl-wrap">
                            <h3>Results For : <span>Marijuana Dispensaries</span></h3>
                            <div class="listing-view-layout">
                                <ul>
                                    <li><a class="grid active" href="#"><i class="fa fa-th-large"></i></a></li>
                                    <li><a class="list" href="#"><i class="fa fa-list-ul"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <!-- listsearch-input-wrap  -->
                        <div class="listsearch-input-wrap fl-wrap">
                            <div class="listsearch-input-item">
                                <i class="mbri-key single-i"></i>
                                <input type="text" placeholder="Keywords?" value=""/>
                            </div>
                            <div class="listsearch-input-item">
                                <select data-placeholder="Location" class="chosen-select" >
                                    <option>All Locations</option>
                                    <option>Bronx</option>
                                    <option>Brooklyn</option>
                                    <option>Manhattan</option>
                                    <option>Queens</option>
                                    <option>Staten Island</option>
                                </select>
                            </div>
                            <div class="listsearch-input-item">
                                <select data-placeholder="All Categories" class="chosen-select" >
                                    <option>All Categories</option>
                                    <option>Shops</option>
                                    <option>Hotels</option>
                                    <option>Restaurants</option>
                                    <option>Fitness</option>
                                    <option>Events</option>
                                </select>
                            </div>
                            <div class="listsearch-input-text" id="autocomplete-container">
                                <label><i class="mbri-map-pin"></i> Enter Addres </label>
                                <input type="text" placeholder="Destination , Area , Street" id="autocomplete-input" class="qodef-archive-places-search" value=""/>
                                <a  href="#"  class="loc-act qodef-archive-current-location"><i class="fa fa-dot-circle-o"></i></a>
                            </div>
                            <!-- hidden-listing-filter -->
                            <div class="hidden-listing-filter fl-wrap">
                                <div class="distance-input fl-wrap">
                                    <div class="distance-title"> Radius around selected destination <span></span> km</div>
                                    <div class="distance-radius-wrap fl-wrap">
                                        <input class="distance-radius rangeslider--horizontal" type="range" min="1" max="100" step="1" value="1" data-title="Radius around selected destination">
                                    </div>
                                </div>
                                <!-- Checkboxes -->
                                <div class=" fl-wrap filter-tags">
                                    <h4>Filter by Tags</h4>
                                    <input id="check-a" type="checkbox" name="check">
                                    <label for="check-a">Elevator in building</label>
                                    <input id="check-b" type="checkbox" name="check">
                                    <label for="check-b">Friendly workspace</label>
                                    <input id="check-c" type="checkbox" name="check">
                                    <label for="check-c">Instant Book</label>
                                    <input id="check-d" type="checkbox" name="check">
                                    <label for="check-d">Wireless Internet</label>
                                </div>
                            </div>
                            <!-- hidden-listing-filter end -->
                            <button class="button fs-map-btn">Update</button>
                            <div class="more-filter-option">More Filters <span></span></div>
                        </div>
                        <!-- listsearch-input-wrap end -->
                    </div>
                </div>
                <!-- list-main-wrap-->
                <div class="list-main-wrap fl-wrap card-listing">
                    <a class="custom-scroll-link back-to-filters btf-r" href="#lisfw"><i class="fa fa-angle-double-up"></i><span>Back to Filters</span></a>
                    <div class="container">
                        <!--@foreach($store as $new_store)-->
                        <!-- listing-item -->
                        <template v-for="store in stores">
                            <div v-if="store.in_view === true" class="listing-item">
                                <article class="geodir-category-listing fl-wrap">
                                    <div class="geodir-category-img" :style="'background: url( '+store.main_img+') center no-repeat'">
                                        <div class="overlay"></div>
                                        <div class="list-post-counter"><span>4</span><i class="fa fa-heart"></i></div>
                                    </div>
                                    <div class="geodir-category-content fl-wrap">
                                        <a class="listing-geodir-category" :href="store.store_url_slug">{{ store.store_type }}</a>
                                        <h3><a :href="store.store_url_slug">{{ store.store_name }}</a></h3>
                                        <p>Sed interdum metus at nisi tempor laoreet. Integer gravida orci a justo sodales, sed lobortis est placerat.</p>
                                        <div class="geodir-category-options fl-wrap">
                                            <div class="listing-rating card-popup-rainingvis" :data-starrating2="store.google_rating"><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>
                                                <span>({{ store.google_rating_count }} google reviews)</span>
                                            </div>
                                            <div class="geodir-category-location"><a href="#0" class="map-item"><i class="fa fa-map-marker" aria-hidden="true"></i> {{ store.store_address }}</a></div>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        </template>
                        <!-- listing-item end-->
                        <!--@endforeach-->
                    </div>
                    <a class="load-more-button" href="#">Load more <i class="fa fa-circle-o-notch"></i> </a>
                </div>
                <!-- list-main-wrap end-->
            </div>
            <!--col-list-wrap end -->
            <div class="limit-box fl-wrap"></div>
            <!--section -->
            <section class="gradient-bg">
                <div class="cirle-bg">
                    <div class="bg" data-bg="images/bg/circle.png"></div>
                </div>
                <div class="container">
                    <div class="join-wrap fl-wrap">
                        <div class="row">
                            <div class="col-md-8">
                                <h3>Join our online community</h3>
                                <p>Grow your marketing and be happy with your online business</p>
                            </div>
                            <div class="col-md-4"><a href="#" class="join-wrap-btn modal-open">Sign Up <i class="fa fa-sign-in"></i></a></div>
                        </div>
                    </div>
                </div>
            </section>
            <!--section end -->
        </div>
        <!--content end -->
        <div class="limit-box fl-wrap"></div>
    </div>
</template>

<script>
    export default {
        props: ['initialStores'],

        data: function() {
            return {
                isActive: undefined,
                storemap: '',
                markers: '',
                marker: [],
                loadedIds: [],
                activeStore: '',
                citySelected: false,
                stores: {},
                markersArray: [],
                zoomCoords: {},
                zoomLevel: '',
                sideHeight: '',
                tiles: '',
                latlng: '',
                dates: new Date(),
                dayText: '',
                winWidth: $(window).width(),
                owlOptions: {
                    margin:10,
                    nav:true,
                    responsive:{
                        0:{
                            items:1
                        },
                        600:{
                            items:3
                        },
                        1000:{
                            items:5
                        }
                    }
                },
                owl: ''
            }

        },

        created: function(){
            let _this = this;
            /*Object.keys(this.initialStores).forEach(function (index, value) {
                _this.stores.push(_this.initialStores[index]);
            });*/
            document.addEventListener("resize", this.getWindowWidth);

        },
        destroyed() {
            document.removeEventListener("resize", this.getWindowWidth);
        },
        mounted() {
            let _this = this;
            this.mainMap();
            //$('.sidebar-listing').height($('.sidebar-listing').outerHeight());
            //this.initSidebar();
            window.onresize = () => {
                this.getWindowWidth();
            }


        },
        computed: {
        },

        methods: {
            mainMap() {
                this.storemap = L.map('map-main');

                this.storemap.on('load', function(){
                    setTimeout(() => {
                        this.invalidateSize(true);
                    }, 800);
                });

                this.storemap.setView([43.6532, -79.3832], 12);
                this.tiles = L.tileLayer('//stamen-tiles-{s}.a.ssl.fastly.net/toner/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }).addTo(this.storemap);

                this.loadMarkers();
                //this.getVisibleMarkers();
                //this.storemap.on('zoomend moveend', this.getVisibleMarkers);
                this.storemap.on('zoomend', this.getVisibleMarkers);
            },
            getWindowWidth(e) {
                this.winWidth = document.documentElement.clientWidth;
            },

            getSingleStore(store_id) {
                let _this = this;
                return axios.post('/api/singlestore/', {store_id: store_id})
                    .then(response => {
                        //console.log(response.data);
                        _this.activeStore = response.data;

                        //console.log(return_store);

                        //this.resizeAndReload();
                    })
                    .catch(error => {
                        console.log(error)
                    });
                //console.log(_this.activeStore);
            },
            loadMarkers() {
                this.markers = L.markerClusterGroup({ chunkedLoading: true });
                for (var i = 0; i < this.initialStores.length; i++) {
                    //console.log(this.stores[i].id + ' for ' + this.stores[i].lat);
                    this.marker[i] = L.marker(L.latLng(this.initialStores[i].lat, this.initialStores[i].lng), {store_id: this.initialStores[i].id, loop_id: i}).on('click', this.markerClicked);

                    //this.markers.addLayer(this.marker[i]);
                    if(this.loadedIds.indexOf(this.initialStores[i].id) === -1) {
                        this.loadedIds.push(this.initialStores[i].id);
                    }
                }

                this.markers.addLayers(this.marker);
                this.storemap.addLayer(this.markers);
                //this.storemap.addLayer(this.markers);
                //console.log('loaded ids is');

                //console.log(this.loadedIds);

            },
            getVisibleMarkers() {
                this.updateZoom();
                let _this = this;
                let current_marker = {};
                let stores_to_get = [];
                if (_this.zoomLevel >= 13) {
                    _this.markers.eachLayer(function (layer) {
                        if (_this.storemap.getBounds().contains(layer.getLatLng())) {
                            current_marker = {};
                            current_marker.id = layer.options.store_id;
                            current_marker.fetched = false;
                            _this.markersArray.push(current_marker);
                        }
                    });
                    _this.markersArray.forEach(function (store){
                        if (store.fetched === false) {
                            stores_to_get.push(store.id);
                        }
                    });
                    axios.post('/api/getmultiplestores/', {stores: stores_to_get})
                        .then(response => {
                            response.data.map(function (value, index) {
                                if (typeof _this.stores[value.id] !== 'object') {
                                    Vue.set(_this.stores, value.id, value)
                                    _this.stores[value.id].in_view = true;
                                    /*_this.stores[value.id] = value;
                                    _this.stores[value.id].in_view = true;*/
                                }
                            });
                        })
                        .catch(error => {
                            console.log(error)
                        });

                    setTimeout(() => {
                        console.log(Object.keys(_this.stores).length);
                        _this.updateInView();
                    }, 400);
                }

                _this.updateInView();
            },
            listingClicked(store_id, lat, lng) {
                console.log(store_id + ' - ' + lat + ' - ' + lng);
                this.storemap.flyTo([lat, lng]);
                this.isActive = store_id;
                this.storemap.setView([lat, lng], 20);
                this.marker[store_id].openPopup();
            },
            markerClicked(marker_id) {
                let _this = this;
                if (typeof _this.stores[marker_id.target.options.store_id] === 'object') {
                    _this.activeStore = _this.stores[marker_id.target.options.store_id];
                } else {
                    this.getSingleStore(marker_id.target.options.store_id);
                }
                setTimeout(() => {
                    this.marker[marker_id.target.options.loop_id].bindPopup('<div class="map-popup-wrap"><div class="map-popup"><div class="infoBox-close"><i class="fa fa-times"></i></div><div class="map-popup-category">' + this.activeStore.store_type + '</div><a href="' + this.activeStore.store_url_slug + '" class="listing-img-content fl-wrap"><img src="' + this.activeStore.main_img + '" alt=""></a> <div class="listing-content fl-wrap"><div class="card-popup-raining map-card-rainting" data-staRrating="' + this.activeStore.google_rating + '"><span class="map-popup-reviews-count">( ' + this.activeStore.google_rating_count + ' reviews )</span></div><div class="listing-title fl-wrap"><h4><a href=/' + this.activeStore.store_url_slug + '>' + this.activeStore.store_name + '</h4><span class="map-popup-location-info"><i class="fa fa-map-marker"></i>' + this.activeStore.store_address + '</span><span class="map-popup-location-phone"><i class="fa fa-phone"></i>' + this.activeStore.store_phone + '</span></div></div></div></div>',
                        {closeButton: false}
                    )
                    this.marker[marker_id.target.options.loop_id].openPopup();
                }, 200);
            },
            directionClick(e, direction) {
                e.preventDefault();
                if (typeof (this.isActive) == "undefined") {
                    let store_index = direction === 'next' ? 0 : (this.marker.length - 1);
                    this.listingClicked(store_index, this.marker[store_index]._latlng.lat, this.marker[store_index]._latlng.lng);
                } else {
                    let new_index = '';
                    if(direction === 'next') {
                        if (this.isActive + 1 < this.marker.length) {
                            new_index = this.isActive + 1;
                        } else {
                            new_index = 0;
                        }
                    } else {
                        if (this.isActive === 0) {
                            console.log('this is running')
                            new_index = (this.marker.length - 1);
                        } else {
                            new_index = this.isActive - 1;
                        }
                    }
                    this.listingClicked(new_index, this.marker[new_index]._latlng.lat, this.marker[new_index]._latlng.lng);
                }
            },
            sidebarListingClicked(store) {
                this.marker[store.id].openPopup();
                this.listingClicked(store.id, store.lat, store.lng);
            },
            updateZoom(){
                this.zoomLevel = this.storemap.getZoom();
            },
            loadStoresInView(bounds) {
                this.updateZoom();
                let _this = this;
                if (_this.stores.length <= 6071 && this.zoomLevel === 14) {
                    this.zoomCoords.neLat = bounds.target.getBounds()._northEast.lat;
                    this.zoomCoords.neLng = bounds.target.getBounds()._northEast.lng;
                    this.zoomCoords.swLat = bounds.target.getBounds()._southWest.lat;
                    this.zoomCoords.swLng = bounds.target.getBounds()._southWest.lng;

                    axios.post('/api/mapzoom/', {coords: this.zoomCoords, loaded_ids: this.loadedIds})
                    .then(response => {

                        //this.stores = {...this.stores, ...response.data };
                        //this.stores = response.data;
                        response.data.map(function (value, index) {
                            if (_this.loadedIds.indexOf(value.id) === -1) {
                                _this.stores.push(value);
                            }
                        });
                        //this.loadMarkers();
                        //this.resizeAndReload();
                    })
                    .catch(error => {
                        console.log(error)
                    });
                }
            },
            updateInView() {
                let _this = this;
                Object.keys(_this.stores).forEach(function (value){
                    if (_this.markersArray.includes(_this.stores[value].id)) {
                        _this.stores[value].in_view = true;
                    } else {
                        _this.stores[value].in_view = false;
                    }
                });
            },
            initSidebar() {
                let _this = this;
                if (window.innerWidth >= 1030) {
                    _this.mapSlyelement = {
                        obj: {},
                        el: '.sidebar-listing',
                        options: {
                            speed: 300,
                            easing: 'swing',
                            activatePageOn: 'click',
                            mouseDragging: 1,
                            touchDragging: 1,
                            scrollBy: 30,
                            dragHandle: 1,
                            dynamicHandle: 1,
                            clickBar: 1,
                            scrollBar: $('.map-view-page .mapview-container .mapview-sidebar .scroll-area .scrollbar'),
                            forward: $('map-view-page .mapview-container .mapview-sidebar .scroll-area .scroll-down i'),
                            backward: $('.map-view-page .mapview-container .mapview-sidebar .scroll-area .scroll-up i')
                        }
                    };


                    $(function () {
                        _this.mapSlyelement.obj = new Sly($(_this.mapSlyelement.el), _this.mapSlyelement.options);
                        _this.mapSlyelement.obj.init();
                    });
                }
            },

            resizeAndReload() {
                this.sideHeight = this.$refs.sidebarListing.clientHeight;

                if (this.winWidth > 768) {
                    console.log('gtrater');
                    $('.sidebar-listing').height(this.sideHeight);
                }
                this.mapSlyelement.obj.reload();
                console.log('resizing');
            },
            pluck(array, key) {
                return array.map(function(obj) {
                    return obj[key];
                });
            },
            isMobile() {
                if(this.winWidth < 1030) {
                    return true
                } else {
                    return false
                }
            },
            getTodayHours (hours){
                switch(this.dates.getDay()) {
                    case 0:
                        this.dayText = 'Sunday';
                        break;
                    case 1:
                        this.dayText = 'Monday';
                        break;
                    case 2:
                        this.dayText = 'Tuesday';
                        break;
                    case 3:
                        this.dayText = 'Wednesday';
                        break;
                    case 4:
                        this.dayText = 'Thursday';
                        break;
                    case 5:
                        this.dayText = 'Friday';
                        break;
                    case 6:
                        this.dayText = 'Saturday';
                        break;
                    default:
                    // code block
                }
                if (hours) {
                    if (typeof hours == 'string') {
                        hours = hours.split(',');
                    }
                    for (var i = 0; i < hours.length; i++) {
                        if (hours[i].includes(this.dayText)) {
                            var today_hours = hours[i].replace('["', '' );
                            return today_hours;
                        }
                    }
                }
            }

        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MapView.vue